export default "__VITE_ASSET__CRnFObtW__"